import { render, staticRenderFns } from "./OrganizationChartNode.vue?vue&type=template&id=6805c583"
import script from "./OrganizationChartNode.vue?vue&type=script&lang=js"
export * from "./OrganizationChartNode.vue?vue&type=script&lang=js"
import style0 from "./OrganizationChartNode.vue?vue&type=style&index=0&id=6805c583&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports